import React from 'react';
import { css } from 'emotion';
import Modal from '@amzn/meridian/modal';

const ConditionOfUsePrivacyNoticePopup = ({
  innerHtmlBodyContent,
  open,
  onClose,
  modalTitle,
}) => {
  return (
    <Modal
      title={modalTitle}
      open={open}
      onClose={onClose}
      scrollContainer="viewport"
      closeLabel="Close">
      <div
        className={css`
          & {
            font-family: AmazonEmber-Regular, Amazon Ember;
          }
        `}
        dangerouslySetInnerHTML={{
          __html: innerHtmlBodyContent,
        }}></div>
    </Modal>
  );
};

export default ConditionOfUsePrivacyNoticePopup;
